import _ from 'lodash'

/**
 * 用提案單中的圖片蓋過現存的賣場圖片
 * @param {Object} proposalListingModels
 */
export const updateImagesBy = proposalListingModels => listingModel => {
  const { sku } = listingModel
  const counterpart = _.find(proposalListingModels, { sku })
  const counterpartImages = _.get(counterpart, 'images', null)
  if (!_.isNull(counterpartImages)) {
    listingModel.images = counterpartImages
  }

  return listingModel
}

export const updateModelImages = (models, proposalListingModels) => {
  const _updateImages = updateImagesBy(proposalListingModels)
  const updatedModels = models.map(_updateImages)
  return updatedModels
}
